import { HabitSchedule, Timeslot, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

import { getScheduleByDate } from './get-schedule-by-date';

export type GetOccurrenceTimeslotOptions = {
  date: Timestamp;
  today: Timestamp;
};

export const getOccurrenceTimeslot = (
  schedules: HabitSchedule[] | undefined | null,
  { date, today }: GetOccurrenceTimeslotOptions,
): Timeslot | null => {
  const schedule = getScheduleByDate(schedules, { date, today });
  const plannedOccurrence = schedule?.plannedOccurrences?.find((occurrence) =>
    isSameDay(occurrence.date, date),
  );

  // A null override wins: that is how one occurrence is made all-day.
  if (plannedOccurrence) {
    return plannedOccurrence.timeslot ?? null;
  }

  return schedule?.timeslot ?? null;
};
